import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class IubendaService {
    private _cookiesBannerInitialized = signal<boolean>(false);
    private readonly _autoblockingSrcBase = 'https://cs.iubenda.com/autoblocking';
    private readonly _csSrc = '//cdn.iubenda.com/cs/iubenda_cs.js';

    get cookiesBannerInitialized(): Signal<boolean> {
        return this._cookiesBannerInitialized.asReadonly();
    }

    initCookiesBanner(siteId: string, cookiePolicyId: string): void {
        const configString = this._buildConfigurationString(siteId, cookiePolicyId);
        const configScript = this._buildBaseScript();
        configScript.innerHTML = configString;
        const autoblockingScript = this._buildBaseScript(['src', this._buildAutoblockingSrc(siteId)]);
        const csScript = this._buildBaseScript(['src', this._csSrc], ['charset', 'UTF-8'], ['async', 'true']);
        document.head.appendChild(configScript);
        document.head.appendChild(autoblockingScript);
        document.head.appendChild(csScript);
        this._cookiesBannerInitialized.set(true);
    }

    private _buildAutoblockingSrc(siteId: string): string {
        return `${this._autoblockingSrcBase}/${siteId}.js`;
    }

    private _buildConfigurationString(siteId: string, cookiePolicyId: string): string {
        return `var _iub = _iub || [];
        _iub.csConfiguration = {
            siteId: ${siteId},
            cookiePolicyId: ${cookiePolicyId},
            lang: 'it',
            storage: { useSiteId: true },
        };`;
    }

    private _buildBaseScript(...attrs: [keyof HTMLScriptElement, string][]): HTMLScriptElement {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        attrs?.forEach(([k, v]) => {
            script.setAttribute(k, v);
        });
        return script;
    }
}
